import { Button, Grid, useMediaQuery } from '@mui/material';
import React, { useEffect, useState } from 'react'
import ClipLoader from 'react-spinners/ClipLoader';
import styled from 'styled-components';
import { useGetAllItemsQuery, useGetAllPopularProductsQuery, useUpdatePopularProductMutation } from '../../features/fullApi';
import Error500 from '../ErrorPages/Error500';
import Product from '../ProductsPages/Smartphones/Smartphone/Smartphone';
import { useTheme } from '@mui/material/styles';
import PopularProduct from './PopularProduct';
import Papa from 'papaparse'

import { useSelector } from 'react-redux';

const Container = styled.div`
   margin-top: 20px;
   margin-left: 350px;
   padding: 30px;
`;

const MobileContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;
`;

const PopularProducts = () => {
    const theme = useTheme()

    let user = useSelector(state => state.auth.user)
    if(!user) {
      user = JSON.parse(localStorage.getItem('user')) || ""
    }
    const isXs= useMediaQuery(theme.breakpoints.down('xs'));
    const isSm= useMediaQuery(theme.breakpoints.down('sm'));
    const isMd= useMediaQuery(theme.breakpoints.down('md'));
    const isLg= useMediaQuery(theme.breakpoints.down('lg'));
    const isXl= useMediaQuery(theme.breakpoints.down('xl'));

    const {data:products, error, isLoading} = useGetAllItemsQuery();

    
    const {data:popularProductsData, error:errorPopularProducts, isLoading:isLoadingPopularProducts} = useGetAllPopularProductsQuery();
    const [popularProducts, setPopularProducts] = useState([])


    useEffect(() => {
      if(!isLoadingPopularProducts) {
        setPopularProducts(popularProductsData[0].products)
      }
    }, [isLoadingPopularProducts])

    let newPopularProducts = []
    const [updatePopularProduct] = useUpdatePopularProductMutation()
    const [csvData, setCsvData] = useState([])
    const [values, setValues] = useState([])

    const [columnArray, setColumnArray] = useState([])
    const handleFile = (event) => {
      Papa.parse(event.target.files[0], {
        header: true,
        skipEmptyLines: true,
        complete: function(result) {
          const columnArray = []
          const valuesArray = []
          console.log("RESULT", result.data.slice(7))
          result.data.slice(9).map((d) => {
            columnArray.push(Object.keys(d))
            valuesArray.push(Object.values(d))
          })

          setCsvData(valuesArray)
          setColumnArray(columnArray[0])
          console.log("VALUES ARRAY", valuesArray)
          

          valuesArray.map(value => {
            products.map(product => {
              console.log("PRODUCT TITLE", product.title)
              console.log("VALUE 0", value[0])
              if(value[0] === product.title) {
                console.log("###FOUND###")
                newPopularProducts.push(product)
              }
            })
          })
          console.log("NEW POPULAR PRODUCTS", newPopularProducts)
          updatePopularProduct({_id: popularProductsData[0]._id, products: newPopularProducts}, { 
            headers: {
              'Token': `Bearer ${user?.accessToken}`
            }
          })
          setPopularProducts(newPopularProducts);
        }
      })
    }


    const renderMobileProducts = () => (
      <div>
        {isLoading ? (
          <div className="flexCenter" style={{height: 'calc(100vh - 70x)'}}>
            <ClipLoader
              color="#93032E"
              loading={isLoading}
              size={150}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>      
        ) : error ? (<Error500></Error500>)
        : (
          <>
            <MobileContainer>
              <h3 style={{textAlign: 'center', margin:'30px 0'}}>Popular products</h3>
              <Grid container rowSpacing={2} columnSpacing={1} className="gridClass">
              {products.slice(0, 10).map((product) => (
                    <Grid key={product._id} item xs={6} lg={3} xl={2}>
                      <Product product={product}/>
                    </Grid>
              ))}
              </Grid>
            </MobileContainer>
          </>)
          }
      </div>)
    
      const renderTabletProducts = () => (
        <div>
        {isLoading ? (
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 64px)'}}>
            <ClipLoader
              color="#93032E"
              loading={isLoading}
              size={150}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>      
        ) 
        : error ? (<Error500></Error500>)
        :(
          <>
            <Grid container spacing={10} className="gridClass">
                {products?.map(product => (
                    <Grid key={product?._id} item>
                        <PopularProduct product={product}/>
                    </Grid>
                ))}
            </Grid>
          </>
        )
      }
      </div>
      )
    
      const renderDesktopProducts = () => (
        <div style={{width: '1200px', margin:'0px auto', display: 'flex', flexDirection: 'column', justifyContent: 'space-around', alignItems:'center'}}>
        {(isLoading) ? (
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 64px)'}}>
            <ClipLoader
              color="#93032E"
              loading={isLoading}
              size={150}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>      
        ) 
        : (error) ? (<Error500></Error500>)
        :(
          <>
              <h1 style={{margin:'50px'}}>Popular Products</h1>

          {user?.isAdmin && (
            <Button
            variant="contained"
            component="label"
            sx={{marginBottom:'50px'}}
          >
            Upload csv
            <input
              type="file"
              hidden
              accept=".csv"
              onChange={handleFile}
            />
          </Button>
          )}
              {popularProducts?.length > 0 ? (
              <Grid container sx={{justifyContent: 'space-between'}}>
                      {popularProducts?.slice(0, 20).map((product) => (
                        <Grid key={product._id} item>
                          <Product product={product}/>
                        </Grid>
                      ))}
              </Grid>
              ) : ""}
          </>
        )
      }
      </div>
      )
    
      return (
        <div>
            {
            (isXs) ?  renderMobileProducts() : 
            (isSm) ? renderMobileProducts() :
            (isMd) ? renderTabletProducts() :
            renderDesktopProducts()
          }
        </div>
      );
}

export default PopularProducts